import validations from "@/locales/en/validations/common.json";

export default {
    validations,
};
